import React from 'react';
import './Avatar.css';

import type { UserDto as User } from '@poker-stats/contracts';
import Flex from '../Flex/Flex';
import Text from '../Text/Text';

type Props = {
  user: User;
};

const Avatar = React.memo(({ user }: Props) => {
  return (
    <Flex className="Avatar" justify="center" align="center">
      <Text size={3}>{user.email[0].toUpperCase()}</Text>
    </Flex>
  );
});

export default Avatar;
